import { React, useState, useEffect } from "react";
import OutsideClickHandler from "react-outside-click-handler";
import classNames from "classnames/bind";

import { LeaderBoardModal } from "../../../../modals";
import PointDropdown from "../../PointDropdown/PointDropdown";
import Button from "../../../Buttons/Button";
import StudentHeaderNavMobile from "./StudentHeaderNavMobile";
import ParentHeaderNavMobile from "./ParentHeaderNavMobile";

import "../../header.scss";
import { CoinIcon, BurgerIcon } from "../../../../../assets";

function ModileHeader({ userInfo, point_earned }) {
  const [pointDropdown, setPointDropdown] = useState(false);
  const [openNavMenu, setOpenNavMenu] = useState(false);
  const [openNavParentProfileMenu, setOpenNavParentProfileMenu] =
    useState(false);
  const [visibleLeaderboardModal, setVisibleLeaderboardModal] = useState(false);

  const mobileHeaderClasses = classNames("mobileHeader", {
    active: openNavMenu,
  });

  useEffect(() => {
    if (openNavMenu) {
      document.body.classList.add("hideScroll");
    } else {
      document.body.classList.remove("hideScroll");
    }
  }, [openNavMenu]);

  function renderMenu() {
    if (userInfo?.account_level === "user") {
      if (openNavMenu) {
        return <StudentHeaderNavMobile userInfo={userInfo} />;
      }
    }

    if (userInfo?.account_level === "manager") {
      if (openNavMenu) {
        return (
          <ParentHeaderNavMobile
            setOpenNavParentProfileMenu={setOpenNavParentProfileMenu}
            openNavParentProfileMenu={openNavParentProfileMenu}
            userInfo={userInfo}
          />
        );
      }
    }
  }

  function renderTopBtns() {
    if (!openNavMenu) {
      return (
        <Button
          image={BurgerIcon}
          customClassName="imageButton"
          onClick={() => setOpenNavMenu(!openNavMenu)}
        />
      );
    } else if (openNavMenu && !openNavParentProfileMenu) {
      return (
        <Button
          iconClassName="hasIcon--close"
          customClassName="imageButton"
          viewType="transparentIcon"
          onClick={() => setOpenNavMenu(false)}
        />
      );
    } else if (openNavMenu && openNavParentProfileMenu) {
      return (
        <Button
          iconClassName="hasIcon--chevron-left"
          customClassName="imageButton"
          viewType="transparentIcon"
          onClick={() => setOpenNavParentProfileMenu(false)}
        />
      );
    }
  }

  return (
    <header className={mobileHeaderClasses}>
      <div className="topElement">
        {renderTopBtns()}

        {userInfo?.account_level === "user" && (
          <OutsideClickHandler onOutsideClick={() => setPointDropdown(false)}>
            <section
              onClick={() => setPointDropdown(!pointDropdown)}
              className="coinButton blackTxt"
              title={userInfo?.name}
            >
              <img
                src={CoinIcon}
                className={`coin-icon ${
                  point_earned &&
                  point_earned !== "false" &&
                  "coin-animation-play"
                }`}
                alt="Coin"
              />
              <span>{userInfo?.points}</span>
              {pointDropdown && (
                <PointDropdown
                  setVisibleLeaderboardModal={setVisibleLeaderboardModal}
                />
              )}
            </section>
          </OutsideClickHandler>
        )}
      </div>

      {renderMenu()}

      {visibleLeaderboardModal && (
        <LeaderBoardModal
          visibleLeaderboardModal={visibleLeaderboardModal}
          setVisibleLeaderboardModal={setVisibleLeaderboardModal}
        />
      )}
    </header>
  );
}

export default ModileHeader;
